import type {
  KeycloakInitOptions,
  KeycloakLoginOptions,
  KeycloakLogoutOptions,
  KeycloakRoles,
  KeycloakTokenParsed,
} from 'keycloak-js';

export type KeycloakLike = {
  init: (options?: KeycloakInitOptions) => Promise<boolean>;
  login: (options?: KeycloakLoginOptions) => Promise<void>;
  logout: (options?: KeycloakLogoutOptions) => Promise<void>;
  updateToken: (minValidity?: number) => Promise<boolean>;
  onAuthSuccess?: () => void;
  onAuthRefreshSuccess?: () => void;
  onAuthLogout?: () => void;
  authenticated: boolean;
  tokenParsed?: KeycloakTokenParsed | null;
  timeSkew?: number | null;
  idTokenParsed?: KeycloakTokenParsed | null;
  realmAccess?: KeycloakRoles;
  token?: string | null;
};

const fallbackInstance: KeycloakLike = {
  init: () => Promise.reject(new Error('Keycloak not initialized')),
  login: async () => {},
  logout: async () => {},
  updateToken: () => Promise.resolve(false),
  authenticated: false,
  tokenParsed: null,
  idTokenParsed: null,
  realmAccess: { roles: [] },
  token: null,
};

let activeInstance: KeycloakLike = fallbackInstance;

// Session lifecycle and notifications belong to userIdentity.
const keycloakProxy = new Proxy<KeycloakLike>(fallbackInstance, {
  get: (_target, prop) =>
    (activeInstance as Record<string | symbol, unknown>)[prop],
  set: (_target, prop, value) => {
    (activeInstance as Record<string | symbol, unknown>)[prop] = value;
    return true;
  },
});
export function setKeycloakInstance(instance: KeycloakLike) {
  activeInstance = instance;
}
export function resetKeycloakInstance() {
  activeInstance = fallbackInstance;
}
export function getKeycloakInstance() {
  return activeInstance;
}
export default keycloakProxy;
